// extracted by mini-css-extract-plugin
export default {"back":"UsersPage_back__y7FL4"};